import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { toastSuccess, toastError } from '../../utils/toast';
import Spinner from '../ui/Spinner';
import logo from '../../assets/logo.png';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!email.trim()) {
      setError('Ingresá tu email.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${apiUrl}/forgot-password`, {
        email: email.trim().toLowerCase(),
      });
      toastSuccess('Si el email está registrado, recibirás un código. Revisá también spam.');
      // Pasamos el email al siguiente paso por state
      navigate('/reset-password', { state: { email: email.trim().toLowerCase() } });
    } catch (err) {
      const msg = err.response?.data?.error || 'No se pudo procesar la solicitud. Intentá de nuevo.';
      setError(msg);
      toastError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-bg p-6 relative overflow-hidden">
      {/* Glow decorativo */}

      <div className="relative w-full max-w-md">
        {/* Brand */}
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img
            src={logo}
            alt="ServiceIn"
            className="w-11 h-11 rounded-xl object-contain"
          />
          <span className="text-xl font-semibold text-ink">ServiceIn</span>
        </div>

        {/* Card */}
        <div className="si-card p-8">
          <h1 className="text-2xl font-bold text-ink mb-1 tracking-tightish">
            Recuperar contraseña
          </h1>
          <p className="text-sm text-ink-3 mb-6">
            Ingresá tu email y te enviaremos un código de 6 dígitos para que puedas crear una nueva contraseña.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="si-label" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="si-input"
                placeholder="tucorreo@ejemplo.com"
                autoComplete="email"
              />
            </div>

            {error && (
              <div className="rounded-xl border border-danger/30 bg-danger/10 px-3 py-2.5 text-sm text-danger">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="si-btn-primary w-full py-3"
            >
              {loading ? (
                <>
                  <Spinner size={16} className="mr-2" />
                  Enviando...
                </>
              ) : (
                'Enviar código'
              )}
            </button>
          </form>

          <div className="mt-6 pt-5 border-t border-line text-center">
            <Link
              to="/"
              className="text-sm text-ink-2 hover:text-ink transition inline-flex items-center gap-2"
            >
              <FaArrowLeft className="text-xs" />
              Volver al login
            </Link>
          </div>
        </div>

        <p className="text-center text-xs text-ink-3 mt-6">
          ServiceIn · Gestión de propinas
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
